module.exports = __webpack_public_path__ + "img/logo.4f3a4806.png";